import React, { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useContent } from "../lib/content";
import ProductCard from "../components/ProductCard";
import SEO from "../components/SEO";
import { Search } from "lucide-react";

export default function ProductsPage() {
  const { products, categories } = useContent();
  const [params, setParams] = useSearchParams();
  const [search, setSearch] = useState("");

  const category = params.get("category") || "";

  const filtered = useMemo(() => {
    let list = products;
    if (category) list = list.filter((p) => p.category === category);
    if (search) {
      const q = search.toLowerCase();
      list = list.filter(
        (p) =>
          p.name.toLowerCase().includes(q) ||
          p.short_description?.toLowerCase().includes(q) ||
          (p.tags || []).some((t) => t.toLowerCase().includes(q))
      );
    }
    return list;
  }, [products, category, search]);

  const setCategory = (key) => {
    if (key) params.set("category", key);
    else params.delete("category");
    setParams(params, { replace: true });
  };

  return (
    <>
      <SEO title="کاتالوگ محصولات | تحسین" description="محصولات طبیعی تحسین: عسل خالص، زعفران هرات و میوه‌های خشک از سراسر افغانستان." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="products-page">
        <header className="text-right mb-10">
          <span className="text-amber-700 font-semibold text-sm tracking-widest uppercase">کاتالوگ تحسین</span>
          <h1 className="text-4xl sm:text-5xl font-black text-stone-900 mt-2 mb-3">محصولات طبیعی</h1>
          <p className="text-stone-600 max-w-2xl">
            محصولاتی که با دقت انتخاب شده‌اند تا طعم واقعی طبیعت را به خانه شما بیاورند.
          </p>
        </header>

        <div className="flex flex-col md:flex-row gap-4 mb-8" data-testid="products-filters">
          <div className="relative flex-1">
            <Search className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="جستجو در محصولات..."
              className="w-full pr-11 pl-4 py-3 rounded-2xl bg-white border border-stone-200 focus:border-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-600/20"
              data-testid="products-search-input"
            />
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setCategory("")}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${
                !category ? "bg-amber-600 text-white" : "bg-white border border-stone-200 text-stone-700 hover:border-amber-400"
              }`}
              data-testid="filter-all"
              data-category-filter="all"
            >
              همه
            </button>
            {categories.map((c) => (
              <button
                key={c.key}
                onClick={() => setCategory(c.key)}
                className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${
                  category === c.key ? "bg-amber-600 text-white" : "bg-white border border-stone-200 text-stone-700 hover:border-amber-400"
                }`}
                data-testid={`filter-${c.key}`}
                data-category-filter={c.key}
              >
                {c.name_fa}
              </button>
            ))}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-20 text-stone-500">هیچ محصولی با این فیلتر یافت نشد.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filtered.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
